'use strict';

let TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
let DutyViewModel=require('../../../dist-es6/client/viewModels/dutyViewModel');
let TripViewModel=require('../../../dist-es6/client/viewModels/tripViewModel');

let BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

DrivePlanService=class DrivePlanService extends BaseService{
static get $inject(){
return['timeZoneService','socketService'];
}

constructor(timeZoneService,socketService){
super();
this._timeZoneService=timeZoneService;
this._socketService=socketService;
}

async getAndInflateRouteScenario(personId,waypoints){
let routeScenarioRequest={
personId:personId,
clientTimeZone:this._timeZoneService.localTimeZone,
waypoints:waypoints.map(wp=>({
address:wp.address,
time:wp.time.toISOString(),
type:wp.type}))};



let routeScenarioResponse=await this._socketService.sendAndWaitForResponse('GetRouteScenario',routeScenarioRequest);

if(routeScenarioResponse.status!=='OK'){
return routeScenarioResponse;
}

let inflatedResponse=this._inflateRouteScenarioResponseFromJson(routeScenarioResponse);

return inflatedResponse;
}

_inflateRouteScenarioResponseFromJson(routeScenarioResponse){
let{statusTransitions,direction,stops}=routeScenarioResponse.route;
let{sleep,fatigue,duties,trips}=routeScenarioResponse.schedule;

return{
route:{
statusTransitions:statusTransitions.map(st=>({time:new Date(st.time),value:st.value})),
direction:direction,
stops:stops},

schedule:{
sleep:sleep.map(s=>new TimeInterval(s)),
fatigue:fatigue.map(f=>({time:new Date(f.time),value:f.value})),
duties:duties.map(d=>new DutyViewModel(d)),
trips:trips.map(t=>new TripViewModel(t))},

queryInterval:new TimeInterval(routeScenarioResponse.queryInterval)};

}};


module.exports=DrivePlanService;
//# sourceMappingURL=drivePlanService.js.map
